import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "jspdf-autotable";
import SparkApi from "../api/SparkApi";

const Home = () => {
  const [dashboard, setDashboard] = useState([]);
  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const dashboardRec = await SparkApi.fetchDashboardRecords();
      setDashboard(dashboardRec);
    } catch (error) {
      console.log("error in dashboard rec", error);
    }
  };

  return (
    <Container>
      <Row className="g-2 g-xl-4 mt-1">
        <Col lg={3} xs={12}>
          <div className="p-1 p-sm-3 d-flex align-items-center home-card">
            <div className="home-card-content">
              <i className="fa fa-industry  card-icon-color-2"></i>
            </div>
            <div className="flex-grow-1 card-text">
              <h6 className="text-muted mb-1">Factory</h6>
              <h4 className="mb-0">{dashboard?.total_factory}</h4>
            </div>
          </div>
        </Col>
        <Col lg={3} xs={12}>
          <div className="p-1 p-sm-3 d-flex align-items-center home-card">
            <div className="home-card-content">
              <i className="fa-solid fa-warehouse  card-icon-color-2"></i>
            </div>
            <div className="flex-grow-1">
              <h6 className="text-muted mb-1">Warehouse</h6>
              <h4 className="mb-0">{dashboard?.total_warehouse}</h4>
            </div>
          </div>
        </Col>
        <Col lg={3} xs={12}>
          <div className="p-1 p-sm-3 d-flex align-items-center home-card">
            <div className="home-card-content">
              <i className="fa-solid fa fa-cubes  card-icon-color-2"></i>
            </div>
            <div className="flex-grow-1">
              <h6 className="text-muted mb-1">Racks</h6>
              <h4 className="mb-0">{dashboard?.total_rack}</h4>
            </div>
          </div>
        </Col>
        <Col lg={3} xs={12}>
          <div className="p-1 p-sm-3 d-flex align-items-center home-card">
            <div className="home-card-content">
              <i className="fa-solid fa-box-open  card-icon-color-2"></i>
            </div>
            <div className="flex-grow-1">
              <h6 className="text-muted mb-1">Products</h6>
              <h4 className="mb-0">{dashboard?.total_products}</h4>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default Home;